<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="chapterheader" id="toc_marker-2-9"><span class="chapterheader1">Chapter 9</span></p>
</div>
<div class="basic-text-frame">
<p class="bodytext2"><span class="dedication1">It was a nasty week of cold sleet, which made for a quiet week in the shop. Tomorrow, my porch furniture would arrive, and I would have dinner with Marc unless he cancelled due to the weather. I went ahead and moved some of my garden-themed merchandise onto the porch downstairs. I’d have to get some plants from nearby Frisella Nursery in Defiance. I didn’t exactly have a green thumb, but I knew that some plants were easier to grow than others. While I was organizing the new space, I got a text from Sarah.</span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="textmessage"><span class="dedication1"></span></p>
<p class="textmessage"><span class="dedication1"></span></p>
<p class="textmessage"><span class="dedication1"></span></p>
<p class="textmessage"><span class="dedication1">I responded: </span></p>
<p class="textmessage"><span class="bodytext5"></span></p>
<p class="textmessage"><span class="bodytext5"></span></p>
<p class="textmessage"><span class="bodytext5"></span></p>
<p class="textmessage"><span class="textmessage1"></span></p>
<p class="textmessage"><span class="bodytext5"></span></p>
<p class="textmessage"><span class="bodytext5"></span></p>
<p class="bodytext2"><span class="dedication1">Just for fun, I told her:</span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1">She replied,</span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1">I texted,</span></p>
<p class="textmessage"><span class="textmessage2"></span></p>
<p class="textmessage"><span class="textmessage2"></span></p>
<p class="textmessage"><span class="textmessage2"></span></p>
<p class="textmessage"><span class="textmessage2"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1">She replied,</span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1">I said,</span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1">I was so glad she didn’t bring up moving to Augusta, like she did during her visit here. Loretta, her mother, said she’d give her blessing regarding Sarah moving here if she finished her degree online and stayed with her mom and dad until the baby was born. I knew the plans would change in time.</span></p>
<p class="bodytext2"><span class="dedication1">I kept doing chores because the day brought me no customers. It gave me time to make lists, which was important for keeping me on track. One list was for all the things I had to do for the upcoming Christmas open house. Another list was for my trip to Green Bay and the gifts I would need to pack. Should I do something special for Marc? I’d have to give that some thought before making a final decision. </span></p>
<p class="bodytext2"><span class="dedication1">After little sleep that night, I got up early to make sure I was ready for the furniture delivery. I looked forward to Marc contacting me about dinner. To my delight, as soon as I finished my morning toast, the furniture truck pulled up in front of my house. I opened the front door. They weren’t the friendliest workers, but at this time of the morning, I understood. I showed them exactly where I wanted them to put everything. I was pleasantly surprised when I saw the green print on the cushions because I had only seen the product online. As soon as I signed the release and the workers had left, I ran back upstairs to see how comfortable everything would be. For the first time, the place smelled like a new house instead of the gigantic antique that it was. I couldn’t wait for Marc to see it!</span></p>
<p class="bodytext2"><span class="dedication1">I opened the shop. The air was freezing cold, but the sun was shining. Thanksgiving and Christmas were at our doorstep, so the weather was typical for this time of year. My mind flashed back to the hot radiators at my flat in the city. They were adequate, but hard to regulate. I wondered if the space had been rented to someone else. This time of year was busy on The Hill. Restaurants were booming, and it was almost impossible to get reservations. I began to feel a little nostalgic about the place I liked so much.</span></p>
<p class="bodytext2"><span class="dedication1">When the phone rang, I jumped. It was Marc saying he’d be by at five to pick me up, if that suited me.</span></p>
<p class="bodytext2"><span class="dedication1">“Sure! I close the shop at four, so it will be perfect. I’ll call The Silly Goose to see if they can seat us tonight. I think you’ll like that place.”</span></p>
<p class="bodytext2"><span class="dedication1">“Sounds great, but I’ve got to run.”</span></p>
<p class="bodytext2"><span class="dedication1">I called the restaurant immediately and got a reservation for six. That was perfect and left us time to have a drink before we left for the restaurant.</span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
<p class="bodytext2"><span class="dedication1"></span></p>
</div>
<div class="frame">
<img alt="207677.png" class="frame2" src="OEBPS/image/207677.png"/>
</div>
<div class="basic-text-frame">
<p class="textmessage"><span class="textmessage2">I had a false alarm and went to the hospital last night. I sure would like this baby girl to come early! I hope you are healing well. I can’t wait to see you at Christmas!</span></p>
</div>
<div class="frame">
<img alt="207709.png" class="frame3" src="OEBPS/image/207709.png"/>
</div>
<div class="basic-text-frame">
<p class="textmessage"><span class="textmessage3">Oh, no! The longer that baby girl stays put, the better! Still no name?</span><span class="textmessage3"></span></p>
</div>
<div class="frame">
<img alt="207914.png" class="frame4" src="OEBPS/image/207914.png"/>
</div>
<div class="frame">
<img alt="208001.png" class="frame5" src="OEBPS/image/208001.png"/>
</div>
<div class="frame">
<img alt="207945.png" class="frame6" src="OEBPS/image/207945.png"/>
</div>
<div class="basic-text-frame">
<p class="textmessage"><span class="textmessage2">No, I have to meet her first.</span></p>
</div>
<div class="basic-text-frame">
<p class="textmessage"><span class="textmessage2">Where are you going for dinner?</span></p>
</div>
<div class="basic-text-frame">
<p class="textmessage"><span class="textmessage2">Way to go! I liked him.</span></p>
</div>
<div class="frame">
<img alt="208033.png" class="frame7" src="OEBPS/image/208033.png"/>
</div>
<div class="basic-text-frame">
<p class="textmessage"><span class="textmessage3">I don’t know. Keep me posted on that baby girl’s activities, ok? Love you! </span><span class="textmessage3"></span></p>
</div>
<div class="frame">
<img alt="207879.png" class="frame8" src="OEBPS/image/207879.png"/>
</div>
<div class="basic-text-frame">
<p class="textmessage"><span class="textmessage3">No big deal. I’m just glad he isn’t mad about me being in an accident with another man! </span><span class="textmessage3"></span></p>
</div>
<div class="frame">
<img alt="207810.png" class="frame9" src="OEBPS/image/207810.png"/>
</div>
<div class="basic-text-frame">
<p class="textmessage"><span class="textmessage3">I have a dinner date with Marc!</span><span class="textmessage3"></span></p>
</div>
<div class="basic-text-frame">
<p class="bodytext"><span class="testimonial-body"></span></p>
<p class="bodytext1"><span class="testimonial-body"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lily_Girl_split12.vue?1d4eb8c6